"use client";

/**
 * Full-panel loading state for scheduler embed slots.
 *
 * Centered bouncing dots inherit the form runtime CSS variables so the
 * loader matches each form's theme. We keep this overlay visible until
 * provider embeds (e.g. Calendly's iframe) finish painting — their own
 * loaders sit at the top of the iframe and can't be repositioned.
 */

const EmbedLoadingSkeleton = () => (
  <div className="embedSkeleton" role="status" aria-busy="true" aria-live="polite">
    <span className="embedSkeleton__srOnly">Loading calendar availability…</span>
    <div className="embedSkeleton__loader" aria-hidden="true">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="embedSkeleton__dot"
          style={{ animationDelay: `${i * 0.16}s` }}
        />
      ))}
    </div>
  </div>
);

export default EmbedLoadingSkeleton;
